// @flow

import React from "react";
import values from "lodash/values";
import flatten from "lodash/flatten";
import isEqual from "lodash/isEqual";
import Select from "../Select";

import type { InputType } from "../../Input/TextInput";
import type { SelectOption } from "../Select";

type AsyncSelectProps = {
  input: InputType,
  options: { [string]: Array<SelectOption> },
  getAsyncOptions: (text: string) => Promise<any>,
  isAsync: boolean,
  optionsToFilter: Array<any>,
  additionalSideSymbolStyle: string,
  prefilledTypedValue?: string
};

type AsyncSelectState = {
  typedValue: string
};

class AsyncSelect extends React.Component<AsyncSelectProps, AsyncSelectState> {
  static defaultProps = {
    optionsToFilter: []
  };

  constructor(props: AsyncSelectProps) {
    super(props);
    const { prefilledTypedValue } = this.props;

    this.state = {
      typedValue: prefilledTypedValue || ""
    };
  }

  handleTypedValue = (typedValue: string) => this.setState({ typedValue });

  getOptionsForTypedValue = (): Array<SelectOption> => {
    const { options, optionsToFilter } = this.props;
    const { typedValue } = this.state;

    if (!typedValue) {
      return [];
    }

    const optionsForTypedValue = options[typedValue] || [];

    return optionsForTypedValue.filter(({ value }) => !optionsToFilter.includes(value));
  };

  getSelectedAsyncOption = () => {
    const {
      options,
      input: { value }
    } = this.props;

    const flatOptions = flatten(values(options));
    const selectedOption =
      flatOptions && flatOptions.length
        ? flatOptions.find(option => isEqual(option.value, value))
        : null;

    return selectedOption;
  };

  render() {
    const {
      input,
      getAsyncOptions,
      options: ignoredOptions,
      isAsync: ignoredAsync,
      additionalSideSymbolStyle,
      ...restProps
    } = this.props;

    return (
      <Select
        input={input}
        options={this.getOptionsForTypedValue()}
        isAsync
        getAsyncOptions={getAsyncOptions}
        onTypedValue={this.handleTypedValue}
        selectedAsyncOption={this.getSelectedAsyncOption()}
        additionalSideSymbolStyle={additionalSideSymbolStyle}
        {...restProps}
      />
    );
  }
}

export default AsyncSelect;
